import React from 'react';
import { Avatar as BaseAvatar } from '@base-ui/react';
import { cn } from '../utils';

interface AvatarProps extends React.HTMLAttributes<HTMLSpanElement> {
  initials: string;
  src?: string;
  alt?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  indicatorColor?: string; // Tailwind color class for dot
}

export const Avatar = React.forwardRef<HTMLSpanElement, AvatarProps>(
  ({ initials, src, alt, size = 'md', className, indicatorColor, ...props }, ref) => {

    const sizes = {
      sm: "w-8 h-8 text-[10px]",
      md: "w-10 h-10 text-xs",
      lg: "w-12 h-12 text-sm",
      xl: "w-16 h-16 text-lg"
    };

    return (
      <BaseAvatar.Root
        ref={ref}
        render={<span />}
        className={cn(
          "relative flex items-center justify-center rounded-full bg-zinc-100 border border-zinc-200 font-bold text-zinc-600 flex-shrink-0 select-none",
          sizes[size],
          props.onClick ? "cursor-pointer" : "",
          className
        )}
        {...props}
      >
        <BaseAvatar.Image
          src={src}
          alt={alt || initials}
          className="h-full w-full rounded-full object-cover"
        />
        <BaseAvatar.Fallback
          delay={0}
          className="flex h-full w-full items-center justify-center rounded-full bg-zinc-100 text-inherit leading-none"
        >
          {initials}
        </BaseAvatar.Fallback>

        {indicatorColor && (
          <div className={cn(
            "absolute bottom-0 right-0 z-10 rounded-full border-2 border-white",
            size === 'sm' ? "w-2.5 h-2.5" : "w-3.5 h-3.5",
            indicatorColor
          )} />
        )}
      </BaseAvatar.Root>
    );
  }
);
Avatar.displayName = "Avatar";
